import {CommonModule, DatePipe} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatInputModule} from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTabsModule} from '@angular/material/tabs';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateModule} from '@ngx-translate/core';
import {PdfJsViewerModule} from 'ng2-pdfjs-viewer';
import {ToastrModule} from 'ngx-toastr';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {NgxTranslateCutModule} from 'ngx-translate-cut';
import {MatSelectSearchModule} from 'src/app/components/mat-select-search/mat-select-search.module';
import {YoutubeVideoPopupComponent} from 'src/app/components/youtube-video-popup/youtube-video-popup.component';
import {AppRoutingModule} from '../../../app-routing.module';
import {SharedComponentModule} from '../../../components/shared-components.module';
import {DocumentViewerComponent} from '../../document-viewer/document-viewer.component';
import * as stages from '../stages';
import {StagesNavigationComponent} from '../stages-navigation/stages-navigation.component';
import {WorkspaceComponent} from '../workspace.component';
import {WsRoutingModule} from './ws-routing.module';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {
  DrivingLicenseInfoComponent
} from '../stages/components/documents/identity-document/infos/driving-license-info/driving-license-info.component';
import {IdInfoComponent} from '../stages/components/documents/identity-document/infos/id-info/id-info.component';
import {PassportInfoComponent} from '../stages/components/documents/identity-document/infos/passport-info/passport-info.component';
import {DocumentsPromptComponent} from '../stages/components/documents/documents-prompt/documents-prompt.component';
import {MonitoringInfoComponent} from '../stages/shared/account-type/monitoring-info/monitoring-info.component';
import {JointInfoComponent} from '../stages/components/joint-info/joint-info.component';
import {
  AllDocumentsInfoComponent
} from '../stages/components/documents/identity-document/infos/all-documents-info/all-documents-info.component';
import {InvestmentInfoComponent} from '../stages/shared/investment/investment-info/investment-info.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {PurposeTypeComponent} from '../stages/components/purpose-type/purpose-type.component';

@NgModule({
  declarations: [
    WorkspaceComponent,
    StagesNavigationComponent,
    DocumentViewerComponent,

    PurposeTypeComponent,

    AllDocumentsInfoComponent,
    DrivingLicenseInfoComponent,
    IdInfoComponent,
    PassportInfoComponent,
    DocumentsPromptComponent,
    MonitoringInfoComponent,
    JointInfoComponent,
    InvestmentInfoComponent,

    stages.PersonalComponent,
    stages.AddressComponent,
    stages.CitizenshipComponent,
    stages.EmploymentComponent,
    stages.EmploymentCitizenshipComponent,
    stages.SubstituteComponent,
    stages.IdentityDocumentComponent,
    stages.AddressDocumentComponent,

    stages.PurposeTypePageComponent,
    stages.AccountTypeComponent,
    stages.JointInfoMobileComponent,

    stages.PersonalSingleComponent,
    stages.PersonalFirstHolderComponent,
    stages.PersonalSecondHolderComponent,

    stages.AddressSingleComponent,
    stages.AddressFirstHolderComponent,
    stages.AddressSecondHolderComponent,

    stages.EmploymentSingleComponent,
    stages.EmploymentFirstHolderComponent,
    stages.EmploymentSecondHolderComponent,

    stages.PersonalInfoCompleteComponent,
    stages.PersonalInfoCompleteFirstHolderComponent,

    stages.InvestmentComponent,
    stages.SourceOfWealthComponent,
    stages.ExperienceComponent,

    stages.ExperienceInfoCompleteComponent,

    stages.RegulatoryComponent,

    stages.SubstituteSingleComponent,
    stages.SubstituteFirstHolderComponent,
    stages.SubstituteSecondHolderComponent,

    stages.GeneralAgreementComponent,

    stages.DocumentsSingleComponent,

    stages.DocumentsFirstHolderComponent,
    stages.DocumentsSecondHolderComponent,
  ],
  imports: [
    CommonModule,
    WsRoutingModule,
    BrowserModule,
    TranslateModule,
    NgxTranslateCutModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    SharedComponentModule,
    ToastrModule.forRoot(),
    BsDatepickerModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSelectSearchModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatTabsModule,
    MatRadioModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    PdfJsViewerModule
  ],
  exports: [WorkspaceComponent],
  providers: [DatePipe]
})
export class WsModule {
}
